import { render, staticRenderFns } from "./StructureAccessPage.vue?vue&type=template&id=3fd922ac"
import script from "./StructureAccessPage.vue?vue&type=script&lang=js"
export * from "./StructureAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports